import { Column, Index } from 'typeorm';

import { ApiProperty } from '../../codegen';
import { IsDate, IsNumber, IsOptional, IsString } from '../../validators';
import { BasicEntity } from '../basic/basic.entity';

@Index(['userId', 'normalizedIp'], { unique: true })
export class UserIpStat extends BasicEntity {
  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false })
  userId: number;

  @ApiProperty()
  @IsString({ groups: ['error'] })
  @Index()
  @Column({ type: 'varchar', nullable: false })
  normalizedIp: string;

  @ApiProperty()
  @IsDate({ groups: ['error'] })
  @Column({ type: 'timestamptz', nullable: false, precision: 3 })
  firstSeenAt: Date;

  @ApiProperty()
  @IsDate({ groups: ['error'] })
  @Column({ type: 'timestamptz', nullable: false, precision: 3 })
  lastSeenAt: Date;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  requestCount: number;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: true })
  userAgentHashLatest?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Index()
  @Column({ type: 'varchar', nullable: true })
  tlsFingerprintHashLatest?: string | null;
}
